module.exports = __webpack_public_path__ + "assets/a-11-yiyongweishengzhi.b531593b.svg";